import agent from "./agent";

export function getOnboardingLogin(search, skip, limit) {
  return agent.get(`onboardingLogins/getList`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addOnboardingLogin(body) {
  return agent.post("onboardingLogins/add", { ...body });
}

export function editOnboardingLogin(id, body) {
  return agent.put(`onboardingLogins/${id}/edit`, { ...body });
} 

export function deleteOnboardingLogin(id) {
  return agent.put(`onboardingLogins/${id}/delete`);
}
